import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UserService } from 'src/app/_services/user.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss'],
})
export class SubNavComponent implements OnInit {
  userRole: string | undefined;
  menuItems: any[] = [];

  constructor(public userService: UserService, public router: Router) {}

  ngOnInit(): void {
    this.userService.currentUser$.subscribe((user) => {
      this.userRole = user?.role?.name;
    });

    this.menuItems = [
      {
        label: 'Dashboard',
        icon: 'pi pi-users',
        routerLink: ['/admin-dashboard'],
        rolesWithAccess: ['admin', 'hq-clinic-admin'],
      },
      {
        label: 'Dashboard',
        icon: 'pi pi-box',
        routerLink: ['/my-clinics'],
        rolesWithAccess: ['clinic-admin'],
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog',
        routerLink: ['/settings'],
        rolesWithAccess: ['hq-clinic-admin', 'clinic-admin'],
      },
      {
        label: 'Products',
        icon: 'pi pi-box',
        routerLink: ['/clinic-products'],
        rolesWithAccess: ['admin', 'hq-clinic-admin'],
      },
      {
        label: 'Orders',
        icon: 'pi pi-shopping-cart',
        routerLink: ['/sales-order'],
        rolesWithAccess: ['admin', 'hq-clinic-admin'],
      },
      {
        label: 'My Orders',
        icon: 'pi pi-shopping-cart',
        routerLink: ['/clinic-orders'],
        rolesWithAccess: ['clinic-admin'],
      }
    ];
  }
}
